import React from 'react';

// Import context
import {
	ShakaPlayerProvider,
	TheoPlayerProvider
} from 'components/context/player/player_vod';

// Import variables
import { DEFAULT_PLAYER, THEO_PLAYER } from 'helpers/variables';

const PlayerVodProvider = (props) => {
	switch (DEFAULT_PLAYER) {
		case THEO_PLAYER:
			return <TheoPlayerProvider {...props} />;

		default:
			return <ShakaPlayerProvider {...props} />;
	}
};

export default PlayerVodProvider;
